import carbonImage from 'openspace/assets/png/carbon.oken.png'
/**
 * A lazy loading for the rarum badge
 **/
export default function LazyBadge({ className }: { className?: string }) {
  return <img src={carbonImage} alt='Carbon Friendly' className={className} />
}
